// Phase 6A · Marketing publish — frontend API client. Additive.
import axios from "axios";
import { API } from "@/contexts/AuthContext";
const BASE = `${API}/marketing/publish`;

export async function proposePublish(payload) {
  const { data } = await axios.post(`${BASE}/propose`, payload);
  return data;
}
export async function confirmPublish(pending_id, confirmation_token) {
  const { data } = await axios.post(`${BASE}/confirm`, {
    pending_id, confirmation_token,
  });
  return data;
}
export async function listPublishLog() {
  const { data } = await axios.get(`${BASE}/log`);
  return data?.items || [];
}
export async function cancelScheduled(id) {
  const { data } = await axios.post(`${BASE}/schedule/${id}/cancel`);
  return data;
}
